(function() {
  let interval = setInterval(function() {
    if (typeof CartItems != undefined) {
      CartItems.prototype.getSectionsToRender_def = CartItems.prototype.getSectionsToRender;
      CartItems.prototype.getSectionsToRender = function() {
        let sections = this.getSectionsToRender_def();
        sections.push({
          id: 'free-shipping-meter',
          section: document.getElementById('free-shipping-meter').dataset.id,
          selector: '.free-shipping-container',
        });

        return sections;
      };
      stop();
    }
  }, 500);
  
  function stop() {
    clearInterval(interval);
  }
  
  setTimeout(stop, 2000);
})();
